import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const Terms = z.object({
  regNumber: z.string(),
  regAddress: z.string(),
  signerEmail: z.string(),
  signerName: z.string(),
  signerPosition: z.string()
});

export const TermsResponse = z.object({
  envelopeId: z.string(),
  customerRequestUrl: z.string()
});

export default c.router({
  signPartnerTerms: {
    method: 'POST',
    path: '/msp/:mspId/terms',
    responses: {
      200: TermsResponse
    },
    body: Terms,
    summary: 'Send out terms to partner'
  },
  signCompanyTerms: {
    method: 'POST',
    path: '/msp/:mspId/customer/:customerId/terms',
    responses: {
      200: TermsResponse
    },
    body: Terms,
    summary: 'Send out terms to company'
  }
});
